// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    baseUrl: 'https://updatesapi.swastika.co.in/api/',
    ipobaseUrl: 'https://ipoapi.swastika.co.in/api/',
    docUrl: 'https://updatesapi.swastika.co.in/',
    searchUrl: 'https://tradingorestapi.swastika.co.in/',
    AppID: 'App1',
    AESKey: 'Swastik@RP#',
    AESKeyTradinGo: 'Swastika@123',
    generationSource:'RESEARCHWEB',
    accessKey: "SWAS@AK6261#",
    SecretKey: "BA2C0CE3-5FAC-4780-AE8D-797B96511F1B",
    KBAESKEY: 'D33E95E9-E4D1-4695-99E9-69EF9B380AA7',
    jarvisEncyKey: 'ThisisAES256Key',
    jarvisBaseURL: 'https://jarvisapi.swastika.co.in/',
    
    // *** LIVE URLS ***//
    // baseUrl: 'https://updatesapi.swastika.co.in/api/',
    // ipobaseUrl: 'https://ipoapi.swastika.co.in/api/',
    // docUrl: 'https://updatesapi.swastika.co.in/',
    // searchUrl: 'https://tradingorestapi.swastika.co.in/',
    // AppID: 'App1',
    // AESKey: 'Swastik@RP#',
    // AESKeyTradinGo: 'Swastika@123',
    
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
